import { render, staticRenderFns } from "./PlanetaryTrack.vue?vue&type=template&id=c47d993a&"
import script from "./PlanetaryTrack.vue?vue&type=script&lang=ts&"
export * from "./PlanetaryTrack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports